import { useNavigate } from 'react-router-dom'
import { Button, HStack, IconButton, Stack, Text, useBreakpointValue, UseDisclosureReturn } from '@chakra-ui/react'
import { useAuth } from 'context'
import { themeColors } from 'theme'

import { DrawerIcon, LogoutIcon, WicarLogo, WicarLogoSmall } from 'components/SVGS'

interface NavBarProps {
  sidebarOptions: UseDisclosureReturn
}

const NavBar: React.FC<NavBarProps> = ({ sidebarOptions }) => {
  const { authState: { state: { user } }, logout } = useAuth()
  const history = useNavigate()

  const { navbar: { bgColor } } = themeColors

  const breakpoint = useBreakpointValue({ base: 'small', md: 'desktop' })

  return (
    <HStack
    bg={bgColor}
    w="full"
    h="full"
    justifyContent="space-between"
    px={4}
    alignItems="center"
    position="sticky"
    top={0}
    zIndex="sticky"
    >
      <HStack spacing={4}>
        {breakpoint === 'small' &&
          <IconButton
            aria-label='Menu'
            variant={'icon'}
            role='group'
            onClick={() => sidebarOptions.onOpen()}
            icon={<DrawerIcon size={30} />}
          />
        }
        <Stack cursor={'pointer'}>{
          breakpoint === 'small'
            ? <WicarLogoSmall onClick={() => history('/my-vehicles')} width={30} height={30} />
            : <WicarLogo onClick={() => history('/my-vehicles')} width={200} height={50} />
        }
        </Stack>
        {user && <Text variant={'LG_SB'} >Hola, {user.name}</Text>}
      </HStack>
      {breakpoint === 'desktop' && <Button variant='link' onClick={logout} rightIcon={<LogoutIcon size={8} />}>
        Cerrar sesión
      </Button>}
    </HStack>
  )
}

export default NavBar
